import clsx from "classnames";
import { Description } from "@/ui";
import classes from "../styles.module.scss";

/**
 * Coloured call-to-action strip under the table: rich text on the left, a white pill button on the right.
 *
 * @param {boolean} [show] - Whether the strip is rendered.
 * @param {string} [text] - Rich text in the strip.
 * @param {string} [label] - Button label.
 * @param {string} [href] - Button link.
 * @param {boolean} [newTab] - Open the button link in a new tab.
 * @param {string} [color] - Fill key for the strip background.
 * @returns {JSX.Element|null}
 */
export default function TableCta({ show, text, label, href, newTab, color }) {
  if (!show || (!text && !label)) return null;

  return (
    <div className={clsx(classes.table__cta, classes[`fill--${color}`])}>
      {!!text && (
        <div className={classes.table__ctaText} data-sourceflow-prop="ctaText">
          <Description description={text} className="mb-0" />
        </div>
      )}

      {!!label && !!href && (
        <a
          className={classes.table__ctaButton}
          href={href}
          target={newTab ? "_blank" : undefined}
          rel={newTab ? "noopener noreferrer" : undefined}
          data-sourceflow-prop="ctaLabel"
        >
          {label}
        </a>
      )}
    </div>
  );
}
